import type { PivotChartSpecPipeline, VChartSpecPipeline } from 'src/types'
import {
  backgroundColor,
  labelBoxPlot,
  tooltipBoxplot,
  color,
  pivotAdapter,
  initPivot,
  datasetPivot,
  pivotIndicators,
  pivotDiscreteLegend,
  pivotGridStyle,
  pivotColumnDimensions,
  pivotRowDimensions,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationAreaBand,
  boxMaxWidth,
  boxGapInGroup,
  progressive,
  colorAdapter,
  linearColor,
  colorLegend,
  pivotColorLegend,
  initBoxplot,
  xBand,
  yLinear,
  verticalCrosshairRect,
  datasetBoxplot,
  pivotAxisStyle,
  pivotTitle,
  dimensionLinkage,
  boxPlotStyle,
  colorBoxPlotStyleFill,
  outlierStyle,
  discreteLegend,
  fontFamilyTheme,
} from '../pipes'

const boxplot: VChartSpecPipeline = [
  fontFamilyTheme,
  initBoxplot,
  boxMaxWidth,
  boxGapInGroup,
  colorAdapter(color, linearColor),
  backgroundColor,
  datasetBoxplot,
  progressive,
  xBand,
  yLinear,
  labelBoxPlot,
  tooltipBoxplot,
  colorAdapter(discreteLegend, colorLegend),
  verticalCrosshairRect,
  colorBoxPlotStyleFill(boxPlotStyle),
  outlierStyle,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationAreaBand,
]

const pivotBoxplot: PivotChartSpecPipeline = [
  initPivot,
  pivotGridStyle,
  datasetPivot,
  pivotIndicators([
    fontFamilyTheme,
    initBoxplot,
    boxMaxWidth,
    boxGapInGroup,
    colorAdapter(color, linearColor),
    backgroundColor,
    datasetBoxplot,
    progressive,
    xBand,
    pivotAxisStyle(yLinear),
    labelBoxPlot,
    tooltipBoxplot,
    colorBoxPlotStyleFill(boxPlotStyle),
    outlierStyle,
    verticalCrosshairRect,
    annotationPoint,
    annotationVerticalLine,
    annotationHorizontalLine,
    annotationAreaBand,
  ]),
  pivotRowDimensions,
  pivotColumnDimensions,
  pivotTitle,
  colorAdapter(pivotDiscreteLegend, pivotColorLegend),
  dimensionLinkage,
]

export const boxplotSpecPipeline = [pivotAdapter(boxplot, pivotBoxplot)]
